export const routesNames = {
  home: 'Home',
  valueEditor: 'ValueEditor',
  history: 'History',
  auditLogs: 'AuditLogs',
  login: 'Login',
  callback: 'Callback'
}

export const sectionsNames = {
  auditLogs: 'Audit Logs'
}

export const uploadStatus = {
  Initial: 0,
  Uploading: 1,
  Success: 2,
  Failed: 3
}



// WEBPACK FOOTER //
// ./src/core/constants.js